// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__WcMq+","opacity-transition":"success_opacity-transition__jXqzZ"};